// Mock data for ADL Cleaning Services

export const heroData = {
  title: "A Spotless Space, Every Time",
  subtitle: "ADL Cleaning Services has been delivering reliable, detailed cleaning for homes and businesses across the region since 2004. Proudly owned and run by Melinda Farrell.",
  phone: "0477 502 583",
  image: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxicmlnaHQlMjBtb2Rlcm4lMjBob21lfGVufDB8fHx8MTc4NTI0NDQ1Mnww&ixlib=rb-4.1.0&q=85"
};

export const statsData = [
  { number: "20+", label: "Years Experience" },
  { number: "500+", label: "Happy Clients" },
  { number: "100%", label: "Satisfaction" }
];

export const servicesData = [
  {
    id: 1,
    title: "Residential Cleaning",
    description: "Regular home cleaning tailored to your schedule — kitchens, bathrooms, living spaces, and everything in between. Move-in and move-out cleans available.",
    features: ["Weekly, fortnightly & monthly", "Deep cleans", "Move-in / move-out"],
    image: "https://images.unsplash.com/photo-1580256081112-e49377338b7f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxyZXNpZGVudGlhbCUyMGNsZWFuaW5nfGVufDB8fHx8MTc4NTI0NDQ4MXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Commercial Cleaning",
    description: "Professional cleaning for offices, retail spaces, and business premises. We keep your workplace spotless so your team can focus on what they do best.",
    features: ["Office & retail", "After-hours service", "Custom contracts"],
    image: "https://images.unsplash.com/photo-1627905646269-7f034dcc5738?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxjb21tZXJjaWFsJTIwY2xlYW5pbmd8ZW58MHx8fHwxNzg1MjQ0NDgxfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Specialty Cleaning",
    description: "Post-construction cleanups, deep spring cleans, and specialised services for when you need that extra level of detail and care.",
    features: ["Post-construction", "Deep spring cleans", "Custom requests"],
    image: "https://images.unsplash.com/photo-1718152421680-d1580e843cc9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBjbGVhbmluZ3xlbnwwfHx8fDE3ODUyNDQ0OTJ8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const storyData = {
  owner: "Melinda Farrell",
  title: "Meet Melinda Farrell, Owner of ADL Cleaning",
  description: "For over 20 years, Melinda Farrell has built ADL Cleaning Services on a simple principle: treat every home and business as if it were her own. What started as a one-woman operation remains a personal, one-on-one service — known for reliability, attention to detail, and genuine care.",
  tagline: "When you choose ADL, you're not just getting a cleaning service — you're getting Melinda personally, who genuinely cares about your space.",
  stats: [
    { label: "Years", value: "20+", subtitle: "of trusted service" },
    { label: "Sole Owner", value: "Melinda Farrell", subtitle: "" },
    { label: "Clients", value: "500+", subtitle: "in Tully & surrounds" }
  ],
  image: "https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjbGVhbmluZ3xlbnwwfHx8fDE3ODUyNDQ0NTF8MA&ixlib=rb-4.1.0&q=85"
};

export const benefitsData = [
  {
    number: "01",
    title: "Fully Insured & Trusted",
    description: "Every member of our team is vetted, trained, and fully insured for your peace of mind."
  },
  {
    number: "02",
    title: "Reliable & Punctual",
    description: "We show up on time, every time. No surprises — just consistent, dependable service."
  },
  {
    number: "03",
    title: "Attention to Detail",
    description: "We don't cut corners. We clean them. Every surface gets the care it deserves."
  },
  {
    number: "04",
    title: "Satisfaction Guaranteed",
    description: "If something isn't right, we'll come back and fix it. That's our promise to you."
  },
  {
    number: "05",
    title: "Eco-Friendly Options",
    description: "We use safe, effective cleaning products that are tough on grime but gentle on your family."
  },
  {
    number: "06",
    title: "Fair, Transparent Pricing",
    description: "No hidden fees. You'll always know exactly what you're paying for before we start."
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Homeowner",
    avatar: "S",
    text: "Melinda and her team have been cleaning our home for over three years now. They're always on time, incredibly thorough, and genuinely lovely people. I couldn't recommend ADL more highly."
  },
  {
    id: 2,
    name: "James Cooper",
    role: "Business Owner",
    avatar: "J",
    text: "We switched to ADL for our office cleaning two years ago and never looked back. The difference in quality is night and day. Reliable, professional, and reasonably priced."
  },
  {
    id: 3,
    name: "Emily Tran",
    role: "Tenant",
    avatar: "E",
    text: "Used ADL for an end-of-lease deep clean and got our full bond back. They were meticulous — the real estate agent even commented on how spotless everything was."
  }
];

export const contactData = {
  phone: "0477 502 583",
  email: "melindafarrell33@hotmail.com",
  serviceArea: "Tully & surrounding areas"
};

// Mock form submission
export const submitContactForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      // Store in localStorage
      const submissions = JSON.parse(localStorage.getItem('adl_submissions') || '[]');
      const newSubmission = {
        ...formData,
        id: Date.now(),
        timestamp: new Date().toISOString()
      };
      submissions.push(newSubmission);
      localStorage.setItem('adl_submissions', JSON.stringify(submissions));
      resolve({ success: true, message: 'Quote request received! We\'ll contact you within 24 hours.' });
    }, 1000);
  });
};
